export default __webpack_public_path__ + "static/moon-bf5c2a01775d3ddecf54c70fe94adcd5.png";